export default __webpack_public_path__ + "static/media/CertificateImage.81c6b0b2.png";